$(document).ready(function() {
  $("body").on("select2:select", function() {
    $(".select2-selection__rendered").css("color", "rgb(0, 0, 0)");
  });
})
